const STARTUP_METRICS_KEY = '__tripflowStartupMetrics';

type StartupMetricsRegistry = {
  t0: number;
  seen: Set<string>;
};

const getRegistry = (): StartupMetricsRegistry => {
  const globalAny = globalThis as typeof globalThis & {
    [STARTUP_METRICS_KEY]?: StartupMetricsRegistry;
  };

  if (!globalAny[STARTUP_METRICS_KEY]) {
    globalAny[STARTUP_METRICS_KEY] = {
      t0: Date.now(),
      seen: new Set<string>(),
    };
  }

  return globalAny[STARTUP_METRICS_KEY] as StartupMetricsRegistry;
};

export function markStartupMetric(step: string, data?: Record<string, unknown>): void {
  const registry = getRegistry();
  if (registry.seen.has(step)) {
    return;
  }
  registry.seen.add(step);
  const elapsedMs = Date.now() - registry.t0;
  try {
    console.warn(`[startup-metric] ${step} elapsedMs=${elapsedMs}`);
  } catch {
    console.warn(`[startup-metric] ${step} elapsedMs=${elapsedMs}`);
  }
}

